import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";

import { Button, Row, Modal, Card, CardBody, Col, CardHeader, Collapse } from "reactstrap";

import { ReactComponent as BusIcon } from "assets/img/Course/upcoming/bus.svg";
import { ReactComponent as MealIcon } from "assets/img/Course/upcoming/meal.svg";
import { ReactComponent as TimeIcon } from "assets/img/Course/upcoming/date.svg";
// import { ReactComponent as RescheduleIcon } from "assets/img/Course/upcoming/reschedule.svg";
// import { ReactComponent as WithdrawalIcon } from "assets/img/Course/trainer.svg";
import { ReactComponent as CertificateIcon } from "assets/img/Course/registration/success.svg";
// import { ReactComponent as TrainerIcon } from "assets/img/Course/trainer.svg";

import ModalCertificates from "./ModalCertificates";
import { PrintCourseDate, PrintDate } from "../../../../common_function/function";
import generalApi from "@/services/general-api";
import BundleCertCard from "components/LearnerPortal/BundleCertCard";
import { useQuery } from "@tanstack/react-query";
import { Spinner } from "reactstrap";

function ModalBundleList() {
	const params = useParams();
	const [serachParms] = useSearchParams();
	const cert_id = serachParms.get("cert_id");

	// const [bundle, setBundle] = useState([]);
	// useEffect(() => {
	// 	generalApi.getBundleDetail(params.id).then((response) => {
	// 		setBundle(response);
	// 	});
	// }, []);

	const query = useQuery({
		queryKey: ["bundle-list", params.id],
		queryFn: () => {
			return generalApi.getBundleDetail(params.id);
		},
	});

	// <>
	// 	<BundleCertCard
	// 		key={i}
	// 		cert={cert}
	// 		initialShowModal={cert_id == cert.certification_id}
	// 	/>
	// </>

	const data = query?.data;

	return (
		<>
			<div className=''>
				<div className='title-container'>
					<h2>Certificates</h2>
					<p className='mb-2' style={{ fontSize: 20, fontWeight: "600", color: "rgb(131,77,149)" }}>
						Professional Certifications
					</p>
				</div>

				{!data && query.isLoading ? (
					<Spinner />
				) : data && data.professional_cert && data.professional_cert.length > 0 ? (
					data.professional_cert.map((cert, i) => {
						return (
							<BundleCertCard
								key={i}
								cert={cert}
								initialShowModal={cert_id == cert.certification_id}
							/>
						);
					})
				) : null}
			</div>
		</>
	);
}

export default ModalBundleList;
